import React, { useEffect, useMemo } from "react";
import { Paper, Typography, Grid, Button, Box, Divider } from "@mui/material";
import ModeOutlinedIcon from "@mui/icons-material/ModeOutlined";
import "./preneed-profile-view.scss";

import { ReactComponent as PhotoIcon } from "../../../../assets/icons/photo-icon.svg";

type Address = Record<string, string | number | null | undefined> & {
  id?: string | number;
};

export type PreneedProfileDetails = {
  fullName?: string;
  businessEmail?: string;
  phoneNumber?: string;
  preneedId?: string | number;
  preneed_id?: string | number;
  address?: Address | null;
  providerId?: string | number;

  //  add these (API may return either)
  profileImage?: string | null;
  profile_photo?: string | null;
  profilePhoto?: string | null;
};

type PreneedProfileViewProps = {
  onEdit: () => void;
  preneedProfileDetails?: PreneedProfileDetails | null;
  isEditMode?: boolean;
};

const PreneedProfileView: React.FC<PreneedProfileViewProps> = ({
  onEdit,
  preneedProfileDetails,
  isEditMode,
}) => {
  const profile = preneedProfileDetails ?? {};

  // Remove id from address
  const address = useMemo<Record<string, string | number | null | undefined>>(() => {
    const addr = profile.address;
    if (!addr) return {};
    return Object.fromEntries(Object.entries(addr).filter(([key]) => key !== "id")) as Record<
      string,
      string | number | null | undefined
    >;
  }, [profile.address]);

  console.log('profile testinggggggg', profile);

  const fullName = profile.fullName ?? "";
  const businessEmail = profile.businessEmail ?? "";
  const phone = profile.phoneNumber ?? "";
  const preneedId = (profile.preneedId ?? profile.preneed_id ?? profile.providerId ?? "") as string | number | "";

  //  profile photo
  const profilePhoto =
    profile.profileImage ?? profile.profile_photo ?? profile.profilePhoto ?? null;

  useEffect(() => { }, [isEditMode]);

  return (
    <Paper className="preneed-profile-view">
      {/* Header */}
      <Box className="preneed-profile-view__header">
        <Box className="preneed-profile-view__header-left">
          {/*  Avatar like form */}
          <Box
            className="preneed-profile-view__avatarWrap"
            onClick={onEdit}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") onEdit();
            }}
          >
            <Box className="preneed-profile-view__avatar">
              {profilePhoto ? (
                <img
                  src={profilePhoto}
                  alt="Profile"
                  className="preneed-profile-view__avatarImg"
                />
              ) : (
                <PhotoIcon className="preneed-profile-view__photoIcon" />
              )}
            </Box>
          </Box>

          {/*  Name + subtitle */}
          <Box className="preneed-profile-view__nameBlock">
            <Typography className="preneed-profile-view__user-name">
              {fullName || "-"}
            </Typography>
            {/* <Typography className="preneed-profile-view__user-profile-text">
              Preneed Profile
            </Typography> */}
          </Box>
        </Box>

        <Button
          onClick={onEdit}
          className="preneed-profile-view__edit-btn"
          startIcon={<ModeOutlinedIcon />}
        >
          Edit Profile
        </Button>
      </Box>

      <Divider />

      {/* Basic Information */}
      <Box className="preneed-profile-view__section">
        <Typography variant="h6" className="preneed-profile-view__section-title">
          Basic Information
        </Typography>

        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <p className="preneed-profile-view__label">Full Name</p>
            <p className="preneed-profile-view__value">{fullName || "-"}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <p className="preneed-profile-view__label">Preneed ID</p>
            <p className="preneed-profile-view__value">
              {preneedId === "" ? "-" : preneedId}
            </p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <p className="preneed-profile-view__label">Business Email Address</p>
            <p className="preneed-profile-view__value">{businessEmail || "-"}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <p className="preneed-profile-view__label">Phone Number</p>
            <p className="preneed-profile-view__value">{phone || "-"}</p>
          </Grid>
        </Grid>
      </Box>

      <Divider />

      {/* Address Information */}
      <Box className="preneed-profile-view__section">
        <Typography variant="h6" className="preneed-profile-view__section-title">
          Address Information
        </Typography>

        {Object.keys(address).length > 0 ? (
          <Grid container spacing={1}>
            {Object.entries(address).map(([key, value]) => (
              <Grid key={key} item xs={12} sm={6}>
                <p className="preneed-profile-view__label">
                  {key === "street" ? "Street/Area" : key.charAt(0).toUpperCase() + key.slice(1)}
                </p>
                <p className="preneed-profile-view__value">
                  {value === null || value === undefined || value === "" ? "-" : String(value)}
                </p>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography className="preneed-profile-view__no-data">
            No address available
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default PreneedProfileView;
